import useProviderOrderCode, { useProviderOrderCodeForm } from '@hooks/useProviderOrderCode'

const mapStateToOrderCode = (state, entityState) => {
  const {
    selectedItem,
    selectedOptions,
    selectedPriceList,
    selectedProduct,
  } = state

  const orderCode = {
    ...entityState,
    options: selectedOptions,
    provider_price_list_id: selectedPriceList.id,
    provider_price_list_item_id: selectedItem.id,
    service_product_id: selectedProduct.id,
  }

  return orderCode
}

const useCreateOrEditProviderOrderCodeModal = (params = {}) => {
  const {
    providerOrderCode,
    state,
  } = params

  const { provider_id } = providerOrderCode || {}

  const {
    selectedItem,
    selectedOptions,
    selectedPriceList,
    selectedProduct,
  } = state

  const {
    callbacks: { createProviderOrderCode, updateProviderOrderCode },
    creating,
    updating,
  } = useProviderOrderCode()

  const providerOrderFormPayload = useProviderOrderCodeForm(providerOrderCode, { validateOn: 'change' })
  const {
    entityState,
    errors,
    handlers,
  } = providerOrderFormPayload

  const { provider_code } = entityState

  const saveEnabled = !!(
    selectedPriceList?.id
    && selectedProduct.id
    && selectedItem.id
    && selectedItem.options?.length === selectedOptions.length
    && provider_code
  )

  const showIdentityCodeField = !!(
    selectedPriceList?.id
    && selectedProduct.id
    && selectedItem.id
    && selectedItem.options?.length === selectedOptions.length
  )

  return {
    callbacks: {
      createProviderOrderCode: () => createProviderOrderCode(mapStateToOrderCode(state, entityState)),
      updateProviderOrderCode: () => updateProviderOrderCode(mapStateToOrderCode(state, entityState)),
    },
    creating,
    entityState,
    errors,
    handlers,
    providerId: provider_id,
    saveEnabled,
    showIdentityCodeField,
    updating,
  }
}

export default useCreateOrEditProviderOrderCodeModal
